import type { ReactNode } from 'react';
import { atom } from 'jotai';
import type { TileCorner } from '../lib/callTile';

// Shell UI state shared between the header/nav and pages (Living Room).

/** Home's conversation search, opened from the header. */
export const homeSearchOpenAtom = atom(false);

/** What the nav's "+" does on the current page; null hides it. */
export interface NavAction {
  label: string;
  onSelect: () => void;
}
export const navActionAtom = atom<NavAction | null>(null);

/**
 * A page that takes the whole screen on phones, with its own back button
 * (a list's checklist). Open chats use openConversationIdAtom instead.
 */
export const fullScreenPageAtom = atom(false);

/**
 * Page-specific buttons in the header, beside the title (Documents: search
 * and grid/list). Pages set it while mounted.
 */
export const headerActionsAtom = atom<ReactNode>(null);

/**
 * A live call shrunk to the floating tile so the app can be used (M70,
 * D267). Reset whenever a call ends.
 */
export const callMinimizedAtom = atom(false);

/**
 * The corner the call tile was last dragged to, for this visit; null until
 * then, when it sits in the default corner for the screen (D267).
 */
export const callTileCornerAtom = atom<TileCorner | null>(null);

/** What the call tile shows: the chat's name and when the call connected. */
export const activeCallInfoAtom = atom<{
  title: string;
  startedAt: number | null;
}>({
  title: '',
  startedAt: null,
});
